import * as React from "react";
import {useCartContext} from "../../../../cart/CartContextProvider/CartContextProvider";
import {PurchaseButtonProps} from "./PurchaseButtonProps";
import DefaultPurchaseButton from "./DefaultPurchaseButton";
import {useCustomerSelector} from "../../../../../store";

/* Apple Pay purchase in summary view */
const ApplePayPurchaseButton: React.FC<PurchaseButtonProps> = ({purchaseButtonErrors}) => {
  const {customer} = useCustomerSelector();

  const {appleData} = useCartContext().viewState;

  return (
    <DefaultPurchaseButton
      purchaseButtonErrors={purchaseButtonErrors}
      paymentInfos={appleData}
      visitorId={customer.visitorId}
      occurrence="Apple Pay Summary Purchase Button"
    />
  );
};

export default ApplePayPurchaseButton;
